"use strict";

var _slicedToArray = require("/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useID = useID;
exports.IDContextProvider = exports.IDContext = exports.componentIdSuffix = exports.nanoidComponentId = void 0;

var _react = _interopRequireWildcard(require("react"));

var _generate = _interopRequireDefault(require("nanoid/non-secure/generate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var nanoidComponentId = function nanoidComponentId() {
  return (0, _generate.default)('0123456789abcdefghijklmnopqrstuvwxyz', 8);
};

exports.nanoidComponentId = nanoidComponentId;

var componentIdSuffix = function componentIdSuffix(_ref) {
  var componentId = _ref.componentId;
  return componentId;
};

exports.componentIdSuffix = componentIdSuffix;
var IDContext = (0, _react.createContext)();
exports.IDContext = IDContext;

var IDContextProvider = function IDContextProvider(_ref2) {
  var _ref2$generateCompone = _ref2.generateComponentId,
      generateComponentId = _ref2$generateCompone === void 0 ? nanoidComponentId : _ref2$generateCompone,
      _ref2$generateSuffix = _ref2.generateSuffix,
      generateSuffix = _ref2$generateSuffix === void 0 ? componentIdSuffix : _ref2$generateSuffix,
      children = _ref2.children;
  var registeredIdsRef = (0, _react.useRef)({});

  var generateId = function generateId(id, componentId) {
    var registeredIds = registeredIdsRef.current;

    if (!registeredIds[id]) {
      var _generatedId = id;
      registeredIds[id] = _defineProperty({}, componentId, _generatedId);
      return _generatedId;
    }

    if (registeredIds[id][componentId]) {
      return registeredIds[id][componentId];
    }

    var count = Object.keys(registeredIds[id]).length;
    var suffix = generateSuffix({
      id: id,
      componentId: componentId,
      count: count,
      registeredIds: registeredIds
    });
    var generatedId = "".concat(id, "-").concat(suffix);
    registeredIds[id][componentId] = generatedId;
    return generatedId;
  };

  return _react.default.createElement(IDContext.Provider, {
    value: {
      generateId: generateId,
      generateComponentId: generateComponentId
    }
  }, children);
};

exports.IDContextProvider = IDContextProvider;

function useID() {
  var _ref3 = (0, _react.useContext)(IDContext),
      generateId = _ref3.generateId,
      generateComponentId = _ref3.generateComponentId;

  var _ref4 = (0, _react.useState)(generateComponentId),
      _ref5 = _slicedToArray(_ref4, 1),
      componentId = _ref5[0];

  var _ref6 = (0, _react.useState)({}),
      _ref7 = _slicedToArray(_ref6, 2),
      generatedIds = _ref7[0],
      setGeneratedIds = _ref7[1];

  return function (id) {
    if (id in generatedIds) {
      return generatedIds[id];
    }

    var generatedId = generateId(id, componentId);
    setGeneratedIds(_objectSpread(_objectSpread({}, generatedIds), {}, _defineProperty({}, id, generatedId)));
    return generatedId;
  };
}